import React from "react"
import { Heading, Text, Box, Link, Image } from "@chakra-ui/react"
import { GatsbyImage } from "gatsby-plugin-image"
import { useYear } from "../../../context/YearContext"

const styles = {
  root: {
    bg: "#FFFFFF",
    p: { base: "20px", md: "36px", lg: "36px" },
    width: "100%",
    boxShadow: "0px 8px 12px 0px #2D37480D",
    borderRadius: "8px",
  },
  heading: {
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "32px",
  },
  text: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#2D3748",
  },
  link: {
    fontSize: "16px",
    color: "#3399FF",
    fontWeight: 400,
    lineHeight: "24px",
  },
  hero: {
    mt: "20px",
    width: "120px",
  },
}

const TemplateItem = ({
  title = "",
  onExampleClick = () => {},
  children,
  imagePath,
}) => {
  const { selectedYear } = useYear()
  return (
    <Box sx={styles.root}>
      <Heading sx={styles.heading}>{title}</Heading>
      <Box mt="4px">
        <Link sx={styles.link} onClick={onExampleClick}>
          See examples
        </Link>
      </Box>

      <Box>{children}</Box>

      {selectedYear === "2024" && (
        <Text sx={styles.text} mt="20px">
          <strong>
            #HealthcareResearchAllStars #oncology, #urology, #gastrointestinal,
            #otolaryngology, #vascularsurgery, #vascular,
            #cardiothoracicsurgery, #neurosurgery, #spine, #spinesurgery,
            #orthopedicsurgery, #orthopedicsurgeon, #orthopedics, #handsurgery,
            #shouldersurgery, #footsurgery, #kneesurgery, #hipsurgery
          </strong>
        </Text>
      )}

      <Box sx={styles.hero}>
        <Image
          as={GatsbyImage}
          alt={"Healthcare Research All-Stars Logo"}
          image={imagePath?.node?.childImageSharp?.gatsbyImageData}
          w="120px"
        />
      </Box>
    </Box>
  )
}

export default TemplateItem
